export function cleanWildcardPath(resolved?: string) {
  if (!resolved) return;
  if (resolved?.endsWith('*')) {
    resolved = resolved?.slice(0, resolved.length - 1);
  }
  return resolved;
}
